import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PPOBApi } from "datas/ppob/PPOBApi";
import { PPOBPartnerAddParams, PPOBPartnerEditParams, PPOBPartnerListParams, PPOBPartnerListResult } from "domains/entity/main/ppob/partner";
import { PPOBInteractor } from "domains/interactor/main/ppob/PPOBInteractor";

interface iState {
  data: PPOBPartnerListResult;
  loading: boolean;
  error: boolean;
}

export const partnerListAction = createAsyncThunk(
  "ppob/partner",
  async (data: PPOBPartnerListParams) => {
    const { pageSize, pageNumber, filterText } = data;
    try {
      const interactor = new PPOBInteractor(new PPOBApi());
      const response = await interactor.getPartnerList({
        pageSize,
        pageNumber,
        filterText
      });
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const addPartnerAction = createAsyncThunk(
  "ppob/partner/add",
  async (data:PPOBPartnerAddParams) => {
    const { partnerId, partnerName, respType, access } = data;
    try {
      const interactor = new PPOBInteractor(new PPOBApi());
      const response = await interactor.addPartnerList({partnerId, partnerName, respType, access});
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const editPartnerAction = createAsyncThunk(
  "ppob/partner/edit",
  async (data:PPOBPartnerEditParams) => {
    const { partnerId, partnerName, respType, access } = data;
    try {
      const interactor = new PPOBInteractor(new PPOBApi());
      const response = await interactor.editPartnerList({partnerId, partnerName, respType, access});
      return response;
    } catch (error) {
      throw error;
    }
  }
);

const initialState: iState = {
  data: {
    list: [],
    total: 0,
  },
  loading: false,
  error: false,
};

const slice = createSlice({
  name: "ppob-partner",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(partnerListAction.pending, (state) => {
        console.log("pending");
        state.loading = true;
        state.error = false;
      })
      .addCase(
        partnerListAction.fulfilled,
        (state, action: PayloadAction<any>) => {
          console.log("fulfilled", action);
          state.data = action.payload;
          state.error = false;
          state.loading = false;
        }
      )
      .addCase(partnerListAction.rejected, (state, action) => {
        console.log("rejected", action);
        state.loading = false;
        state.error = true;
      });
  },
});

const ppobPartnerReducer = slice.reducer;
export default ppobPartnerReducer;
